import React from "react";

const PanelFooter = ({ children }) => {
  return (
    <div class="panel-footer">
      <div class="panel-footer-text">{children}</div>
    </div>
  );
};

export default PanelFooter;



// WEBPACK FOOTER //
// ./src/_components/UI/Panel/PanelFooter/index.js